import React, { useEffect, useRef, useState } from "react";
import { SketchPicker } from "react-color";

interface Props {
    label: string;
    color: string;
    onChange: (hex: string) => void;
}

export function ColorPickerField({ label, color, onChange }: Props) {
    const [open, setOpen] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClick = (e: MouseEvent) => {
            if (ref.current && !ref.current.contains(e.target as Node)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClick);
        return () => document.removeEventListener("mousedown", handleClick);
    }, []);

    return (
        <div data-testid="color-picker-field" className="d-flex align-items-center justify-content-between">
            <span style={{ fontWeight: 600 }}>{label}</span>
            <div
                className="d-flex align-items-center"
                style={{ position: "relative" }}
            >
                <div
                    data-testid="color-picker-swatch"
                    style={{
                        width: 36,
                        height: 36,
                        borderRadius: 6,
                        backgroundColor: color,
                        border: "1px solid #ccc",
                        cursor: "pointer",
                        marginRight: 8,
                    }}
                    onClick={() => setOpen(!open)}
                />
                <span style={{ fontSize: 13, color: "#666" }}>{color}</span>
                {open && (
                    <div
                        ref={ref}
                        style={{
                            position: "absolute",
                            top: 44,
                            right: 0,
                            zIndex: 10,
                        }}
                    >
                        <SketchPicker
                            color={color}
                            onChange={(c) => onChange(c.hex)}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}
